export enum AccountRole {
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    COACH = 'COACH',
    PARENT = 'PARENT',
    CHILD = 'CHILD',
}

export enum Weekday {
    MON = 'MON',
    TUE = 'TUE',
    WED = 'WED',
    THU = 'THU',
    FRI = 'FRI',
    SAT = 'SAT',
    SUN = 'SUN',
}

export enum WeekdayLabel {
    MON = 'Poniedziałek',
    TUE = 'Wtorek',
    WED = 'Środa',
    THU = 'Czwartek',
    FRI = 'Piątek',
    SAT = 'Sobota',
    SUN = 'Niedziela',
}

export enum WeekdayIndex {
    MON = 1,
    TUE = 2,
    WED = 3,
    THU = 4,
    FRI = 5,
    SAT = 6,
    SUN = 7,
}

export enum FreePositions {
    MUCH = 3,
    MEDIUM = 2,
    FEW = 1,
    NO = 0,
}

export enum LockSubscriptionsEnum {
    LOCK = 'LOCK',
    FULL = 'FULL',
    OPEN = 'OPEN',
}

export enum LockAgreementsEnum {
    LOCK = 'LOCK',
    FULL = 'FULL',
    OPEN = 'OPEN',
}

export const LockSubscriptionsEnumLabels: Record<
    LockSubscriptionsEnum,
    string
> = {
    [LockSubscriptionsEnum.LOCK]: 'Zablokowane (ręcznie)',
    [LockSubscriptionsEnum.FULL]: 'Zablokowane (automat.)',
    [LockSubscriptionsEnum.OPEN]: 'Otwarte (automat.)',
} as const;

export const LockAgreementsEnumLabels: Record<LockAgreementsEnum, string> = {
    [LockAgreementsEnum.LOCK]: 'Zablokowane (ręcznie)',
    [LockAgreementsEnum.FULL]: 'Zablokowane (automat.)',
    [LockAgreementsEnum.OPEN]: 'Otwarte (automat.)',
} as const;

export enum PaymentStatus {
    NEW = 'NEW',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    PARTLY = 'PARTLY',
    CANCELLED = 'CANCELLED',
}

export const PaymentStatusLabels: Record<PaymentStatus, string> = {
    [PaymentStatus.NEW]: 'Do zapłaty',
    [PaymentStatus.PENDING]: 'Przetwarzanie',
    [PaymentStatus.SUCCESS]: 'Opłacone',
    [PaymentStatus.FAILURE]: 'Brak wpłaty',
    [PaymentStatus.PARTLY]: 'Niepełna wpłata',
    [PaymentStatus.CANCELLED]: 'Anulowano',
} as const;

export enum PaymentPurpose {
    SPORTSWEAR = 'SPORTSWEAR',
    REGISTRATION = 'REGISTRATION',
    REGISTRATION_LIGHT = 'REGISTRATION_LIGHT',
    SUBSCRIPTION = 'SUBSCRIPTION',
    OTHER = 'OTHER',
}

type AchievementsMODULE_RESOURCES_ARR =
    | 'achievements'
    | 'childAchievements'
    | 'challenges'
    | 'childChallenges'
    | 'groupChallenges'
    | 'childExperience';

export type ResourceTypes =
    | 'accounts'
    | 'children'
    | 'groups'
    | 'groupTypes'
    | 'schools'
    | 'regions'
    | 'timeSheets'
    | 'trainings'
    | 'parents'
    | 'agreements'
    | 'companies'
    | 'payments'
    | 'messages'
    | 'sportsWear'
    | 'daysOff'
    | 'itemsDict'
    | 'orders'
    | 'settings'
    | 'supabaseAccounts'
    | 'archiveGroups'
    | 'dictionaries'
    | 'dictionaryItems'
    | AchievementsMODULE_RESOURCES_ARR
    | 'agreementTemplates';

export enum OrderStatus {
    NEW = 1,
    PREPARING = 4,
    SEND = 2,
    DONE = 3,
}

export enum OrderDispatchType {
    COURIER = 1,
    PERSONAL = 2,
}

export const OrderStatusLabels: Record<OrderStatus, string> = {
    [OrderStatus.NEW]: 'Nowe',
    [OrderStatus.DONE]: 'Zakończone',
    [OrderStatus.SEND]: 'Wysłano',
    [OrderStatus.PREPARING]: 'Przygotowywane',
} as const;

export enum AgreementCancelReason {
    EXPIRED = 'EXPIRED',
    DEPRECATED_RESCIND = 'RESCIND',
    DEPRECATED_CANCELED_BY_PARENT = 'CANCELED',
    IMMEDIATE = 'IMMEDIATE',
    DEFERRED = 'DEFERRED',
    AMENDMENTS = 'AMENDMENTS',
}

export const AgreementCancelReasonLabels: Record<
    AgreementCancelReason,
    string
> = {
    [AgreementCancelReason.DEFERRED]: 'Rozwiązana',
    [AgreementCancelReason.IMMEDIATE]: 'Unieważniona',
    [AgreementCancelReason.EXPIRED]: 'Wygasła',
    [AgreementCancelReason.DEPRECATED_RESCIND]: 'DEPRECATED_RESCIND',
    [AgreementCancelReason.DEPRECATED_CANCELED_BY_PARENT]:
        'DEPRECATED_CANCELED_BY_PARENT',
    [AgreementCancelReason.AMENDMENTS]: 'Zmiany w umowie',
} as const;

export enum DelayedPaymentsEnum {
    NO = 'no',
    DELAYED_REGISTRATION = 'delayed-registration',
    DELAYED_SUBSCRIPTION = 'delayed-subscription',
}

export type PickKeys<T, K extends keyof T> = Extract<keyof T, K>;

export enum ChallengeStatus {
    NEW = 'NEW',
    PENDING = 'PENDING',
    DONE = 'DONE',
}

//
// export const DictMetaType = {
//     STRING: 'STRING',
//     NUMBER: 'NUMBER',
//     JSON: 'JSON',
//     JSON_ARRAY: 'JSON_ARRAY',
//     JSON_FORM: 'JSON_FORM',
// }


export enum DictMetaType {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    JSON = 'JSON',
    JSON_ARRAY = 'JSON_ARRAY',
    JSON_FORM = 'JSON_FORM',
}


export enum DictionaryType {
    EXAM_TYPES = 'EXAM_TYPES',
    PROFILE_POSITIONS = 'PROFILE_POSITIONS',
    PROFILE_FOOT = 'PROFILE_FOOT'
}
